import { createReducer, on } from '@ngrx/store';
import { resetData, updateData, updateDataVisibility, updateSelectedData } from '../actions/data.actions';

/* XML sample :
<doc43>
  <partie_machine ident="SAM04352000219" desfr="" desan="" desal="ABLAGREBOTER">
    <page numpage="1" ident="SAM00206NPR1501-01" desfr="" desan="" desal="EINGABE TRENNBOGEN">
      <piece>
        <id>1</id>
        <numident>SAM00206NPR1501-01-1</numident>
        <numbobst>SAM0206P00001</numbobst>
        <desfr>PLAQUE</desfr>
        <desan>PLATE</desan>
        <desal>PLATTE</desal>
        <val> </val>
        <remarque>x1</remarque>
      </piece>
      <piece>
        <id>2</id>
        <numident>SAM00206NPR1501-01-2</numident>
        <numbobst>SAM0206P00002</numbobst>
        <desfr>RAIDISSEUR</desfr>
        <desan>STIFFENER</desan>
        <desal>VERSTEIFUNG</desal>
        <val> </val>
        <remarque>x1</remarque>
      </piece>
*/


export interface Doc43Node {
  '#text': string[];
  partie_machine: PartieMachineNode[];
}

export interface PartieMachineNode {
  '#text': string[];
  '@attributes': PartieMachineNodeAttributes;
  page: PageNode[];
}

export interface PartieMachineNodeAttributes {
    desal: string;
    desan: string;
    desfr: string;
    ident: string;
}

export interface PageNode {
  '#text': string[];
  '@attributes': PageNodeAttributes;
  piece: PieceNode[];
}

export interface PageNodeAttributes {
    desal: string;
    desan: string;
    desfr: string;
    ident: string;
    numpage: string;
}

export interface PieceNode {
  '#text': string[];
  desal: string;
  desan: string;
  desfr: string;
  id: string;
  numbobst: string;
  numident: string;
  remarque: string;
  val: string;
}


export interface INITIAL_DATA {
  [any: string]: Doc43Node;
}

// PArtieMachineNode is what we get from XML parsing, effects will convert it to PartieMachineNodeAugmented to add visible property
export interface PartieMachineNodeAugmented extends PartieMachineNode {
  visible: boolean;
}

export interface DATA {
  pages: PartieMachineNodeAugmented[];
  selectedPage: {};
}

export const data: DATA = {
  pages: [],
  selectedPage: {}
};

export const dataReducer = createReducer(
  data,
  on(updateData, (state, { pages }) => ({ ...state, pages })),
  on(updateDataVisibility, (state, { selectedPage }) => {
    const _data: DATA['pages'] = JSON.parse(JSON.stringify(state.pages));
    _data[selectedPage['index']]['visible'] = !_data[selectedPage['index']]['visible'];
    return { ...state, pages: _data };
  }),
  on(updateSelectedData, (state, { selectedPage }) => ({
    ...state,
    selectedPage
  })),
  on(resetData, (state) => ({ selectedPage: {}, pages: [] }))
);
